export const LIVE_FEED_URLS = Object.freeze({
  midrand_service_hub: 'https://stage.bcx.probaanalytics.io/camera/?t=1787650158344'
});

export const LIVE_FEEDS = Object.freeze({
  midrand_service_hub: Object.freeze({
    label: 'Midrand Service Hub Camera',
    url: LIVE_FEED_URLS.midrand_service_hub
  })
});
